/* LEHUA · Pop-up Newsletter — trigger 8s + exit intent + 30 day dismiss
   Submit: AJAX pra /contact (cria Customer no Shopify com tags). */

(function () {
  'use strict';

  const STORAGE_KEY = 'lehua_popup_dismissed';
  const COOLDOWN_DAYS = 30;
  const TRIGGER_DELAY_MS = 8000;

  function shouldShow() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return true;
      const ts = parseInt(stored, 10);
      if (isNaN(ts)) return true;
      const days = (Date.now() - ts) / (1000 * 60 * 60 * 24);
      return days >= COOLDOWN_DAYS;
    } catch (_) { return true; }
  }

  function markDismissed() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
  }

  let opened = false;
  let userClosed = false;
  let keepOpenObserver = null;
  let popup, dialog, form, formState, successState, focusableBefore;

  function openPopup() {
    if (opened) return;
    if (!popup) return;
    opened = true;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    focusableBefore = document.activeElement;
    const firstField = dialog.querySelector('.lehua-popup__field input');
    if (firstField) setTimeout(() => firstField.focus(), 100);
    document.addEventListener('keydown', onKey);
  }

  function closePopup() {
    if (!opened) return;
    userClosed = true;
    if (keepOpenObserver) { keepOpenObserver.disconnect(); keepOpenObserver = null; }
    opened = false;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    markDismissed();
    if (focusableBefore && focusableBefore.focus) focusableBefore.focus();
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) { if (e.key === 'Escape') closePopup(); }

  // Após mostrar o cupom, mantém o popup aberto até o CLIENTE fechar (no X, fora, ou Esc).
  // Cobre várias formas de "fechar sozinho": remover a classe is-open, aplicar display:none,
  // ou reverter o estado de sucesso. Se algo externo tentar, a gente restaura.
  function lockOpenUntilUserCloses() {
    if (keepOpenObserver || !popup) return;
    keepOpenObserver = new MutationObserver(function () {
      if (userClosed) return;
      var brokenOpen = !popup.classList.contains('is-open') || popup.style.display === 'none';
      var brokenSuccess = successState && successState.hidden;
      if (!brokenOpen && !brokenSuccess) return;
      popup.classList.add('is-open');
      if (popup.style.display === 'none') popup.style.removeProperty('display');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (successState) successState.hidden = false;
      if (formState) formState.hidden = true;
    });
    keepOpenObserver.observe(popup, { attributes: true, attributeFilter: ['class', 'style'] });
    if (successState) keepOpenObserver.observe(successState, { attributes: true, attributeFilter: ['hidden'] });
  }

  function showSuccess() {
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    lockOpenUntilUserCloses();
  }

  async function submitForm(e) {
    e.preventDefault();
    const submitBtn = form.querySelector('.lehua-popup__submit');
    const originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Enviando...'; }
    try {
      const fd = new FormData(form);
      // Shopify form action /contact — salva o cliente com email + nome (first_name) + tags.
      await fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' });
      // Shopify normalmente retorna 302 redirect ou 200 — em ambos casos tratamos como sucesso
      showSuccess();
    } catch (err) {
      console.warn('Lehua popup submit failed:', err);
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
      alert('Erro ao enviar. Tenta de novo em alguns segundos.');
    }
  }

  function copyCoupon(el) {
    const code = el.dataset.couponCopy;
    if (!code) return;
    const action = el.querySelector('.lehua-popup__coupon-action');
    const orig = action ? action.textContent : '';
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(() => {
        if (action) {
          action.textContent = 'Copiado ✓';
          setTimeout(() => { if (action) action.textContent = orig; }, 2000);
        }
      });
    }
  }

  function init() {
    popup = document.getElementById('lehua-popup-newsletter');
    if (!popup) return;
    dialog = popup.querySelector('.lehua-popup__dialog');
    form = popup.querySelector('[data-lehua-popup-form]');
    formState = popup.querySelector('[data-lehua-popup-form-state]');
    successState = popup.querySelector('[data-lehua-popup-success-state]');

    popup.querySelectorAll('[data-lehua-popup-close]').forEach(el => {
      el.addEventListener('click', closePopup);
    });

    if (form) form.addEventListener('submit', submitForm);

    const coupon = popup.querySelector('[data-coupon-copy]');
    if (coupon) coupon.addEventListener('click', () => copyCoupon(coupon));

    if (!shouldShow()) return;

    // Trigger 1: timer
    const timer = setTimeout(openPopup, TRIGGER_DELAY_MS);

    // Trigger 2: exit intent (desktop only)
    function onMouseOut(e) {
      if (e.clientY <= 0 && !opened) {
        clearTimeout(timer);
        openPopup();
        document.removeEventListener('mouseout', onMouseOut);
      }
    }
    if (window.matchMedia('(min-width: 768px)').matches) {
      document.addEventListener('mouseout', onMouseOut);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
